import React, { Component } from 'react';
import { Card, Row, Col, Table, Button, Input, ButtonGroup, Alert as Alert2, Badge } from "reactstrap";
import { api, filterHelper, stringHelper, dateHelper } from "../helpers";
import { TextFilter, FilterSet, SelectFilter, DateFilter, ActiveToggleFilter, Pager } from "../components";
import Alert from "react-s-alert";
import Select from "react-select";
import DatePicker from "react-datepicker";
import ToggleButton from 'react-toggle-button';
import moment from "moment";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const emptyPart = {
  partNumber: '',
  description: '',
  partCategory: null,
  partUnitOfMeasure: null,
  minimumOnHand: '',
  maximumOnHand: '',
  netSuiteInventoryItem: true,
  deprecatedOn: null
}

const getProductCategories = () =>
  api
    .fetch("Reference/PartCategories")
    .then(response => {
      return {
        partCategoryList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
      };
    })
    .catch(x => console.error(x));

const getPartUnitsOfMeasure = () =>
  api
    .fetch("Reference/PartUnitOfMeasures")
    .then(response => {
      return {
        partUnitOfMeasureList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
      };
    })
    .catch(x => console.error(x));


export default class Part extends Component {
  static displayName = Part.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      editPart: null,
      filters: [],
      pagedList: null,
      sortColumn: "PartNumber",
      sortAscending: true,
      partCategoryList: [],
      partUnitOfMeasureList: []
    }
    this.addPart = this.addPart.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSave = this.onSave.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
  }

  componentDidMount() {
    Promise.all([getProductCategories(), getPartUnitsOfMeasure()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => {
        this.refreshList()
      });
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/Parts", payload)
      .then(response => {
        if (response && response.data) {
          let formattedList = response.data.dataSource;
          formattedList = _.map(formattedList, item => {
            return {
              id: item.id,
              partNumber: item.partNumber,
              description: item.description,
              partCategory: stringHelper.resolveValue(null, item.partCategoryId, item.partCategoryName),
              partUnitOfMeasure: stringHelper.resolveValue(null, item.partUnitOfMeasureId, item.partUnitOfMeasureName),
              minimumOnHand: item.minimumOnHand != null ? stringHelper.nullableString(String(item.minimumOnHand)) : '',
              maximumOnHand: item.minimumOnHand != null ? stringHelper.nullableString(String(item.maximumOnHand)) : '',
              deprecatedOn: item.deprecatedOn ? moment(item.deprecatedOn).toDate() : null,
              netSuiteInventoryItem: item.netSuiteInventoryItem
            }
          });

          this.setState({
            ...resolvedSort,

            pagedList: {
              list: formattedList,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            editPart: null,
            message: null,
            messageColor: null,
            isMessageVisible: false,
          });
        }
      })
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  addPart() {
    this.setState({
      editPart: emptyPart
    })
  }

  onInputChange(e, fieldName) {
    this.setState({
      editPart: { ...this.state.editPart, [fieldName]: e.target.value }
    })
  }

  onSelectChange(selection, fieldName) {
    this.setState({
      editPart: {
        ...this.state.editPart,
        [fieldName]: selection
      }
    });
  }

  onDateChange(date, fieldName) {
    this.setState({
      editPart: {
        ...this.state.editPart,
        [fieldName]: date }
    })
  }

  onToggleButtonChange(value, fieldName) {
    this.setState({
      editPart: {
        ...this.state.editPart,
        [fieldName]: !this.state.editPart[fieldName]
      }
    });
  }

  onCancel() {
    this.setState({
      editPart: null
    });
  }

  isFormValid() {
    let warnings = [];
    if (this.state.editPart.partNumber === "") {
      warnings.push("Part number is required.");
    }
    if (this.state.editPart.description === "") {
      warnings.push("Description is required.");
    }
    if (!this.state.editPart.partCategory) {
      warnings.push("Please select a category.");
    }
    if (!this.state.editPart.partUnitOfMeasure) {
      warnings.push("Please select a unit of measure.");
    }
    if (this.state.editPart.minimumOnHand < 0 ) {
      warnings.push("Minimum on Hand must be greater than 0.");
    }
    if (this.state.editPart.maximumOnHand < 0 ) {
      warnings.push("Maximum on Hand must be greater than 0.");
    }
    this.setState({
      message: warnings.length ? warnings.join(" ") : null,
      messageColor: "danger",
      isMessageVisible: true
    });
    return warnings.length === 0;
  }

  onSave() {
    if (!this.isFormValid()) return;
    let part = Object.assign({}, this.state.editPart);
    let payload = {
      PartNumber: part.partNumber,
      Description: part.description,
      PartCategoryId: part.partCategory.value,
      PartUnitOfMeasureId: part.partUnitOfMeasure.value,
      MinimumOnHand: part.minimumOnHand ? parseInt(part.minimumOnHand, 10) : null,
      MaximumOnHand: part.maximumOnHand ? parseInt(part.maximumOnHand, 10) : null,
      DeprecatedOn: part.deprecatedOn,
      NetSuiteInventoryItem: part.netSuiteInventoryItem
    }
    if (part.id) {
      payload.Id = part.id;
    }
    api.post("Admin/SavePart", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(`${part.description} has been saved.`)
          this.refreshList();
          this.props.refreshAll();
        } else {
          if (response.data.message) {
            Alert.error(response.data.message)
          } else {
            Alert.error("An error occurred. The part could not be created at this time.")
          }
        }
      }).catch(error => Alert.error("There was an error creating the part."));
  }

  onEdit(partId) {
    let list = this.state.pagedList.list.slice();
    let part = _.find(list, t => {
      return t.id === partId
    })
    this.setState({
      editPart: part
    });
    window.scrollTo(0, 0);
  }

  render() {
    let editPart = this.state.editPart;
    return (
      <div>
        <Row>
          <Col><h5>Parts</h5></Col>
          <Col className="mr-3">
            {this.state.editPart ? null : (
              <Button size="sm" color="success" className="float-right" onClick={this.addPart}>Add New Part</Button>
            )}
          </Col>
        </Row>
        {this.state.message ? (
          <Alert2 color={this.state.messageColor} toggle={() => this.onDismiss()}>{this.state.message}</Alert2>
        ) : null}

        {this.state.editPart ? (
          <Card className="p-2">
            <Row>
              <Col md="4">Part Number: 
                <Input
                  type="text"
                  name="partNumber"
                  maxLength="40"
                  id="partNumber"
                  onChange={(e) => this.onInputChange(e, "partNumber")}
                  value={editPart.partNumber}
                />
              </Col>
              <Col>Description: 
                <Input
                  type="text"
                  name="description"
                  maxLength="200"
                  id="description"
                  onChange={(e) => this.onInputChange(e, "description")}
                  value={editPart.description}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md="3">Category:
                <Select
                  closeMenuOnSelect={true}
                  value={editPart.partCategory}
                  options={this.state.partCategoryList}
                  onChange={(e) => this.onSelectChange(e, "partCategory")}
                />
              </Col>
              <Col md="3">Unit of Measure:
                <Select
                  closeMenuOnSelect={true}
                  value={editPart.partUnitOfMeasure}
                  options={this.state.partUnitOfMeasureList}
                  onChange={(e) => this.onSelectChange(e, "partUnitOfMeasure")}
                />
              </Col>
              <Col md="3">Minimun On Hand:
                <Input
                  type="number"
                  name="minimumOnHand"
                  id="minimumOnHand"
                  onChange={(e) => this.onInputChange(e, "minimumOnHand")}
                  value={editPart.minimumOnHand}
                  min={0}
                />
              </Col>
              <Col md="3">Maximum On Hand:
                <Input
                  type="number"
                  name="maximumOnHand"
                  id="maximumOnHand"
                  onChange={(e) => this.onInputChange(e, "maximumOnHand")}
                  value={editPart.maximumOnHand}
                  min={0}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md="3">Deprecated On:
                <div>
                  <DatePicker
                    selected={editPart.deprecatedOn}
                    className="form-control"
                    placeholderText="Select date deprecated on"
                    onChange={(e) => this.onDateChange(e, "deprecatedOn")}
                  />
                </div>
              </Col>
              <Col>
                <span>
                  Is Net Suite Inventory Item?
                  <ToggleButton
                    value={editPart.netSuiteInventoryItem}
                    activeLabel={"Yes"}
                    inactiveLabel={"No"}
                    onToggle={(value) => {
                      this.onToggleButtonChange(value, "netSuiteInventoryItem")
                    }}
                  />
                </span>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ButtonGroup className="float-right">
                  <Button size="sm" color="secondary" className="buttonGroupSpacing" onClick={this.onCancel}>Cancel</Button>
                  <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onSave()}>{editPart.id ? "Update" : "Save"}</Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        ) : null}

        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor">
              <Col xs="3">
                <TextFilter
                  filterName="partNumber"
                  displayName=" Part Number"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <TextFilter
                  filterName="description"
                  displayName=" Description"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <SelectFilter
                  filterName="partCategoryId"
                  displayName="Category"
                  isSingleSelect={true}
                  options={this.state.partCategoryList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "partCategoryId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="3">
                <SelectFilter
                  filterName="partUnitOfMeasureId"
                  displayName="Part Unit Of Measure"
                  isSingleSelect={true}
                  options={this.state.partUnitOfMeasureList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "partUnitOfMeasureId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <DateFilter
                  filterName="deprecatedFrom"
                  displayName="Deprecated From"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "deprecatedFrom",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <DateFilter
                  filterName="deprecatedTo"
                  displayName="Deprecated To"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "deprecatedTo",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="isNetSuiteInventoryItem"
                  displayName="Net Suite Only"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "isNetSuiteInventoryItem",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>
        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Part Number</th>
                  <th>Description</th>
                  <th>Category</th>
                  <th>Unit Of Measure</th>
                  <th>Minimum On Hand</th>
                  <th>Maximum On Hand</th>
                  <th>Net Suite?</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map(part => (
                    <tr key={`pg-${part.id}`}>
                      <td style={{width: "10%"}}>
                        {part.partNumber}
                        {part.deprecatedOn
                          ? <div>
                              <Badge color="danger" title={dateHelper.formatStringDate(part.deprecatedOn)}>
                                Deprecated
                              </Badge>
                            </div>
                          : null
                        }
                      </td>
                      <td style={{width: "30%"}}>{part.description}</td>
                      <td style={{width: "10%"}}>{part.partCategory.label}</td>
                      <td>{part.partUnitOfMeasure.label}</td>
                      <td>{part.minimumOnHand}</td>
                      <td>{part.maximumOnHand}</td>
                      <td> 
                          {part.netSuiteInventoryItem ? (
                            <FontAwesomeIcon
                              icon="check-circle"
                              className="ml-1 mt-0 mb-0 mr-2 pointer  bool-icon"
                              title="Yes"
                            />
                          ) : null}
                        </td>
                      <td>
                        <ButtonGroup className="float-right">
                          {/* {part.deactivatedAt === null ? ( */}
                            <React.Fragment>
                              <Button
                                size="sm"
                                className="cbdmdPrimary buttonGroupSpacing"
                                onClick={() => this.onEdit(part.id)}
                                disabled={this.state.editPart !== null}
                                title="Edit"
                              >
                                <FontAwesomeIcon
                                  icon="edit"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer"
                                  title="Edit"
                                />
                              </Button>
                              {/* <Button
                                size="sm"
                                className="cbdmdDanger buttonGroupSpacing"
                                onClick={() => this.onDelete(part.id)}
                                disabled={this.state.editPart !== null}
                                title="Delete"
                              >
                                <FontAwesomeIcon
                                  icon="trash-alt"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer "
                                  title="Delete"
                                />
                              </Button> */}
                            </React.Fragment>
                          {/* ) : (
                              <Button size="sm" className="cbdmdInfoTeal" onClick={() => this.onRevive(part.id)} disabled={this.state.editPart !== null}>Revive</Button>
                            )} */}
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))
                ) : (
                    <tr>
                      <td>
                        No Records available
                    </td>
                    </tr>
                  )}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />
          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Part.js